// src/features/permissions/components/PermissionsHeader.tsx
import { PageHeader } from '../../../app/components/foundation';

/**
 * Page-top header for Permissions Foundation. Reuses the shared
 * PageHeader primitive (same contract every other feature's header
 * uses) and puts one disabled placeholder in the actions slot to
 * reserve visual space for a future "افزودن نقش" action. It has no
 * click handler and does nothing yet — wiring it to a real create
 * flow is a later phase, not this one. Same pattern as
 * security/components/SecurityHeader.tsx and
 * analytics/components/AnalyticsHeader.tsx.
 */
export function PermissionsHeader({ onCreateRole }: { onCreateRole: () => void }) {
  return (
    <PageHeader
      title="دسترسی‌ها"
      description="مشاهده و مدیریت نقش‌ها و سطوح دسترسی کاربران پلتفرم."
      actions={
        <button
          type="button"
          className="vania-permissions-action-primary"
          title="ایجاد نقش برای یک Tenant موجود"
          onClick={onCreateRole}
        >
          افزودن نقش
        </button>
      }
    />
  );
}
